import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneInput } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'

interface IProps {
  defaultValue?: string
  required?: boolean
}
const CustomIdNoField: FC<IProps> = (props) => {
  const { defaultValue, required = false } = props
  const { t } = useTranslation()

  return (
    <FormItem
      name="provider_custom_id_no"
      initialValue={defaultValue}
      label={`${t('logistics.create.eoriNumber')}${required ? '' : t('logistics.create.optional')}`}
      required={required}
      rules={RULES.provider_custom_id_no({
        isRequired: required,
      })}
    >
      <OneInput placeholder={t('common.input.placeholder')} />
    </FormItem>
  )
}

export default CustomIdNoField
